export default "__VITE_ASSET__DOhs1Zyd__"